import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

export default function Action ({ onClick, href, target, icon, dataAttr, label, title, className, style, iconStyle }) {
  return (
    <a
      href={href}
      target={target}
      onClick={onClick}
      className={className || 'course-action-action'}
      title={title || label}
      data-attr={dataAttr}
      style={style}
    >
      <span className={icon} style={iconStyle} />
      {label ? <div className='action-label'>{label}</div> : null}
    </a>
  )
}

Action.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  href: PropTypes.string,
  target: PropTypes.string,
  icon: PropTypes.string,
  dataAttr: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  iconStyle: PropTypes.string
}
